import React, {Component} from "react";
// import Chart from "chart.js";
import "./About.css"
import gcp from "./skill_logos/gcp.png";
import tensorflow from "./skill_logos/tensorflow.svg";
import pytorch from "./skill_logos/pytorch.svg";
import spark from "./skill_logos/spark.svg";
import java from "./skill_logos/java.png";
import react from "./skill_logos/react.png";
import python from "./skill_logos/python.png";
import javascript from "./skill_logos/javascript.png";

class About extends Component {
    
    render() {
        
        return (
            <div>
                <div>
                    <h1 id="home-h1">About Kartik</h1>
                </div>
                <div>
                    <div className="about-header">
                        <h2>Hi! I am Kartik Bhartiya, I am current pursuing B.Tech. in Electrical Engineering
                            from Motilal Nehru National Institute of Technology, Allahabad. My major interest lies 
                            in Data Science, Big Data and Web Development. I am a self learner, always eager to learn and I have developed
                            a quality to find solutions to complex industrials problems. 
                        </h2>
                    </div>
                    <div className="about-container">
                        <div className="about-contact">
                            <h1>#Contact Details</h1>
                            <p></p>
                            <div className="about-contact-items">
                                <i class='fas fa-user' style={{fontSize:'30px'}}></i>
                                <h3>Kartik Bhartiya</h3>
                            </div>
                            <div className="about-contact-items">
                                <i class='far fa-address-book' style={{fontSize:'28px'}}></i>
                                <h3>B-120, P.C. Colony<br /> Kankarbagh, Patna-20<br />
                                Patna, Bihar<br />
                                India</h3>
                            </div>
                            <div className="about-contact-items">
                                <i class="material-icons">call</i>
                                <h3>+91-7463938715</h3>
                            </div>
                            <div className="about-contact-items">
                                <i class="material-icons">mail_outline</i>
                                <h3>kbhartiya83@gmail.com</h3>
                            </div>
                            <div className="about-contact-items">
                                <i class="fa fa-github" style={{fontSize:'28px'}}></i>
                                <h3>github.com/kbhartiya</h3>
                            </div>
                            
                            
                        </div>
                        <div className="about-exp">
                            <h1>#Experience</h1>
                            <p></p>
                            <ol>
                                <li>
                                    <h4>Hyperworks Imaging Pvt. Ltd.</h4>
                                    <h6>May '19 - July '19</h6>
                                    <h6>Machine Learning Intern</h6>

    
                                </li>
                                <li>
                                    <h4>Cogknit Semantics Pvt. Ltd.</h4>
                                    <h6>May '18 - July '18</h6>
                                    <h6>Machine Learning Intern</h6>
                                </li>
                                <li>
                                    <h4>L&T</h4>
                                    <h6>Dec '17 - Jan '18</h6>
                                    <h6>Intern</h6>
                                </li>
                                
                            </ol>
                        </div>
                    </div>    
                    <div className="about-container">
                        
                         <div class="about-skills">
                            <h1>#Skills</h1> 
                            <p></p>
                            <div className="about-skills-icons">
                                <div className="logo-skill">
                                    <a href="https://www.python.org/">
                                        <img src={python} alt="python" width={128} height={128}/>
                                    </a>
                                </div>
                                <div className="logo-skill">
                                    <a href="https://www.java.com/en/">

                                        <img src={java} alt="java" width={128} height={128}/>
                                    </a>
                                </div>
                                <div className="logo-skill">
                                    <a href="https://reactjs.org/">
                                        <img src={react} alt="react" width={128} height={128}/>
                                    </a>
                                </div>
                                <div className="logo-skill">
                                    <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript">
                                        <img src={javascript} alt="Javascript" width={128} height={128}/>
                                    </a>
                                </div>
                            </div>
                            <div className="about-skills-icons">
                                <div className="logo-skill">
                                    <a href="https://cloud.google.com/">
                                        <img src={gcp} alt="GCP" width={128} height={128}/>
                                    </a>
                                </div>
                                <div className="logo-skill">
                                    <a href="https://spark.apache.org/">
                                        <img src={spark} alt="Apache Spark" width={128} height={128}/>
                                    </a>
                                </div>
                                <div className="logo-skill">
                                    <a href="https://www.tensorflow.org/">
                                        <img src={tensorflow} alt="tensorflow" width={128} height={128}/>
                                    </a>
                                </div>
                                <div className="logo-skill">
                                    <a href="https://pytorch.org/">
                                        <img src={pytorch} alt="pytorch" width={128} height={128}/>
                                    </a>
                                </div>


                                {/* <img src="https://img.icons8.com/officel/160/000000/react.png" width={128} height={128} /> */}
                            </div>
                         </div>       
                    </div> 
                    <div className="about-container">
                        <div class="about-skills">
                                <h1>#Certificates</h1> 
                                <p></p>
                        </div>
                    </div>   
                </div>     
            </div>   
        );
    }
}

export default About;
